<div>
	<div class="center-page blue-pattern-bg">
		<div class="flex-login">
			<div class="login-logo">
				<a>
					<img src="/assets/images/white-moniepoint-logo.svg" alt="Moniepoint">
				</a>
			</div>
			<div class="login-holder card m-t-30">
				<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="align-center">
					<div nz-col class="gutter-row" [nzSpan]="24">
						<h2>Device Registration</h2>
						<div>
							We’ve just sent you a 6 digit code. Check your messages and enter it here.
						</div>
					</div>
				</div>
				<div>
					<form [formGroup]="form" (ngSubmit)="next()" class="m-t-30 animate__animated animate__fadeIn">

						<app-floating-label-input [controlDef]="otpControl" label="Enter OTP" placeHolder="Enter OTP">
						</app-floating-label-input>
						<nz-alert [nzMessage]="loanDesc" class="m-t-10 m-b-10 info-alert-box" nzType="info" nzShowIcon>
							<ng-template #loanDesc>
								Didn't get the code? dial <a><strong>*553*63# </strong></a>
							</ng-template>
						</nz-alert>
						<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>

						<div class="m-t-40">
							<app-custom-submit-button name="Next" [block]="true" [submitting]="submittingForm">
							</app-custom-submit-button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>